import qs from "qs";
export class ProviderClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/providers`;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    
   const url =  `${this.baseURL}${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async post(params) {
    const url = this.baseURL;

    const response = await this.httpClient.request("post", url, {
      data: params
    });

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }

  async getLocalization(id, language) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url, {
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async putLocalization(id, params, language) {
    const url = `${this.baseURL}/${id}/translation`;

    const response = await this.httpClient.request("put", url, {
      data: params,
      headers: { "x-accept-language": language }
    });

    return response;
  }

  async exportExcel(id) {
    const url = `${this.baseURL}/excel/${id}`;

    const response = await this.httpClient.request("get", url, { responseType: "blob" });

    return response;
  }

  async getReport(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/report/excel/download${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/subscriptions/providers.js